module.exports = __webpack_public_path__ + "img/map-marker-alt.0005cde6.svg";